<template>
  <z-card class="widget-financial-aid-card">
    <z-title
      class="widget-financial-aid-card__title"
      align="left"
      size="small"
    >
      {{ $t('title') }}
    </z-title>

    <z-text
      tag="p"
      class="widget-financial-aid-card__paragraph"
    >
      {{ $t('paragraph') }}
    </z-text>

    <z-button
      variant="secondary"
      tag="a"
      href="https://querobolsa.com.br/programas-do-governo"
      class="widget-financial-aid-card__cta"
    >
      {{ $t('cta') }}
    </z-button>

    <VLazyImage
      :alt="$t('image-alt')"
      :src="$asset('pi03oc00ob_001.svg', { source: 'kong' })"
      class="widget-financial-aid-card__image"
    />
  </z-card>
</template>

<script>
import VLazyImage from 'v-lazy-image/v2'

export default {
  name: 'FinancialAidSimulatorCard',
  components: {
    VLazyImage,
  },
  i18n: {
    messages: {
      'pt-BR': require('./i18n/widget-search_financial_aid.json'),
    },
  },
}
</script>

<style lang="scss" scoped>
.widget-financial-aid-card {
  display: grid;
  grid-template-areas:
    (
      'image'
      'title'
      'paragraph'
      'cta'
    );
  justify-items: start;

  @media (min-width: $breakpoint-desktop) {
    align-items: center;
    column-gap: var(--unit-0600);
    grid-template-areas:
      (
        'title     image'
        'paragraph image'
        'cta       image'
      );
    grid-template-columns: 2fr 1fr;
  }
}

.widget-financial-aid-card__title {
  grid-area: title;
}

.widget-financial-aid-card__paragraph {
  grid-area: paragraph;
  margin-bottom: var(--unit-0600);
  margin-top: var(--unit-0400);
}

.widget-financial-aid-card__cta {
  grid-area: cta;
  width: 100%;

  @media (min-width: $breakpoint-desktop) {
    width: auto;
  }
}

.widget-financial-aid-card__image {
  height: 103px;
  width: 128px;
  grid-area: image;
  margin-bottom: var(--unit-0800);
  margin-left: auto;
  margin-right: auto;
  max-width: 128px;

  @media (min-width: $breakpoint-desktop) {
    margin-bottom: var(--unit-0000);
  }
}
</style>
